import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {
  ContractService,
  Registration,
  GetRegistrationsRequest,
} from '@app/core/services/contract/contract.service'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

@Injectable()
export class RegistrationListService extends GenericListService<Registration> {
  filter: SearchFilter

  constructor(
    private contractSvc: ContractService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Registration>> {
    // build the service request
    const svcRequest: GetRegistrationsRequest = {
      domain: request.domain,
      offset: request.offset,
      results: request.count,
      entries: true,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.contractSvc.getRegistrations(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Registration> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
